import { Icon } from "@/components/Icon";
import { UserInfo } from "@/types/Api/User/User/MyAccount/login";
import { amountFormat } from "@/utils/tool";
import { Grid } from "antd-mobile";
// import { UserInfo } from '@/types/APIUserMyAccountLogin';
import styles from "./BalanceDetail.module.scss";

type Item = {
  text: string;
  field: "validSellBalance" | "sumSellAmount" | "sumFrozenAmount";
  color: string;
};

const balance_items: Item[] = [
  { text: "可售数量", field: "validSellBalance", color: "#FF9900" },
  { text: "卖单余额", field: "sumSellAmount", color: "#01B14E" },
  { text: "交易中", field: "sumFrozenAmount", color: "#F76260" },
];

type BalanceDetailProps = {
  userInfo: UserInfo;
};
export default function BalanceDetail({ userInfo }: BalanceDetailProps) {
  return (
    <Grid columns={3} gap={8} className={styles.balance_detail}>
      {balance_items.map((item) => (
        <Grid.Item key={item.field} className={styles.balance_detail_item}>
          <div className={styles.balance_detail_text}>{item.text}</div>
          <div
            className={styles.balance_detail_vol}
            style={{ color: item.color }}
          >
            {amountFormat(userInfo[item.field], { places: 2 }) || "-"}
          </div>
          <div>
            <Icon name={"Vbi"} size={"24px"} />
          </div>
        </Grid.Item>
      ))}
    </Grid>
  );
}
